import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'magnific-popup/dist/magnific-popup.css';
import slick from 'slick-carousel';
import magnificPopup from 'magnific-popup';
import 'jquery-inview';
import 'lazysizes';
{
	let loadDeferredStyles = function() {
		let addStylesNode = document.getElementById("deferred-styles");
		let replacement = document.createElement("div");
		replacement.innerHTML = addStylesNode.textContent;
		document.body.appendChild(replacement)
		addStylesNode.parentElement.removeChild(addStylesNode);
	};
	let raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
	if (raf) raf(function() { window.setTimeout(loadDeferredStyles, 0); });
	else window.addEventListener('load', loadDeferredStyles);
	let a =".ua";
}
{

	function getParam(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	//slick
	$(document).ready(function(){
		var
		//top slider option
		top_slider_option = {
			arrows : false,
			dots : true,
			autoplay : true,
			fade : true,
			autoplaySpeed : 4000
		},
		//first view slider option
		konome_slider_option = {
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows : false,
			dots : false,
			autoplay : true,
			autoplaySpeed: 3000,
			speed: 1400,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			waitForAnimate: false,
			swipe: false,
			swipeToSlide: false,
			touchMove: false
		},
		//konome contents slider option
		konome_slider_option02_obj ={
			dots : false,
			pauseOnFocus: false,
			pauseOnHover: false,
			pauseOnDotsHover: false,
			waitForAnimate: false,
			swipe: false,
			swipeToSlide: false,
			touchMove: false,
			autoplaySpeed : 2500,
			speed : 1000
		};
		//Top
		$('#TopSlider').slick(top_slider_option);

		//konome
		//top left & bottom center & top right slider
		konome_slider_option.initialSlide = 5;
		$('#KonomeSlider01').slick(konome_slider_option);
		konome_slider_option.initialSlide = 7;
		$('#KonomeSlider03').slick(konome_slider_option);
		konome_slider_option.initialSlide = 10;
		$('#KonomeSlider05').slick(konome_slider_option);

		//top center & bottom left & bottom right slider
		// konome_slider_option.speed = 1000;
		// konome_slider_option.autoplaySpeed = 1000;
		konome_slider_option.initialSlide = 3;
		$('#KonomeSlider02').slick(konome_slider_option);
		konome_slider_option.initialSlide = 1;
		$('#KonomeSlider04').slick(konome_slider_option);
		konome_slider_option.initialSlide = 9;
		$('#KonomeSlider06').slick(konome_slider_option);
		//contents slider
		//konome  slider option merge
		var
		konome_slider_option02 = Object.assign(top_slider_option, konome_slider_option02_obj);
		$('#KonomeSlider07').slick(konome_slider_option02);
	});
	//inview
	$('.AnmElem').on('inview', function(event, isInView){
		if (isInView) {
			$(this).addClass('fadeIn');
		}else{
			$(this).removeClass('fadeIn');
		}
	});
	//Header
	$(function(){
		var
			$Header = $('#Header'),
			$SpOpenBtn = $('#SpBtn'),
			$CloseBtn = $('#CloseBtn');

		function AccFunc($elm){
			if($elm.hasClass('on')){
				$elm.removeClass('on');
				$elm.next().slideUp();
			}else{
				$elm.addClass('on');
				$elm.next().slideDown();
			}
		}
		$SpOpenBtn.on('click',function(){
			if($Header.hasClass('On')){
				$Header.removeClass('On');
			}else{
				$Header.addClass('On');
			}
		});
		$CloseBtn.on('click',function(){
			$Header.removeClass('On');
		});
		//popup
		if($(".popup-modal").length){
			$('.popup-modal').magnificPopup({
				type: 'inline',
				preloader: false
			});
			$(document).on('click', '.PopupClose', function (e) {
				e.preventDefault();
				$.magnificPopup.close();
			});
		}
		//product
		if($("#Product").length){
			var urlHash = getParam('anc');
			$('.u-Acc').next().css('display','none');
			if(urlHash){
				function anc_move(hash){
					console.log('上からの位置:' + document.getElementById(hash).offsetTop);
					console.log($('#Header').innerHeight());
					console.log(document.getElementById(hash).offsetTop - $('#Header').innerHeight());
					var qa_position = $('#'+ hash).offset().top - $('#Header').innerHeight();
					$("html,body").animate({scrollTop:qa_position});
						$('.ProductTtl--05.u-Acc').addClass('on');
						$('.ProductTtl--05.u-Acc').next().slideDown();
				}
				anc_move(urlHash);
			}
			var
			//slider option
			slider_option = {
				arrows : true,
				dots : true,
				autoplay : false,
				fade : true,
				autoplaySpeed : 4000
			},
			//Lp slider option
			lp_slider_option = {
				arrows : true,
				dots : false,
				autoplay : false,
				infinite: false
			};
			$('.ProductSlider').slick(slider_option);
			$('.RecomendSlider').slick(slider_option);
			$('#LpSlider').slick(lp_slider_option);
		}
		if($("#Qa").length){
			function btnRemoveClass(){
				$('.QaBtnList__item').each(function(){
					$(this).removeClass('On');
				});
			}
			function tabFadeOut(){
				$('.Tab').each(function(){
					$(this).fadeOut();
				});
			}
			var urlHash = getParam('tab');
			if(urlHash){
				//get hash
				btnRemoveClass();
				tabFadeOut();
				$('.TabBtn[href="#'+urlHash+'"]').parent().addClass('On');
				$('.Tab[id="'+urlHash+'"]').fadeIn();
				$('body,html').animate({scrollTop:0}, 0, 'swing');
			}
			$('.TabBtn').on('click',function(e){
				e.preventDefault();
				tabFadeOut();
				btnRemoveClass();
				$(this).parent().addClass('On');
				var
					tab = $(this).attr('href'),
					tabNum = tab.split('#');
				$('.Tab[id="'+tabNum[1]+'"]').fadeIn();
			});
		}
		//Acc
		$('.u-Acc').on('click',function(){
			AccFunc($(this));
		});
	});
}
